import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexRow, FlexCol, Text } from '../misc';

// @flex
// TODO: Usage of Flex-Component is inconsistent here
export const HeaderNavItem = styled(FlexRow)`
  background-color: inherit;
  position: relative;
`;

export const HeaderNavItemWithBorder = styled(HeaderNavItem)`
  height: 45px;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
  }

  @media screen and (min-width: 64em) {
    border-bottom: 2px solid transparent;
    padding: 0 ${themeGet('space.3')}px;
    background-color: #fff;
    margin-right: ${themeGet('space.3')}px;
    border-radius: 4px;
    box-shadow: 0 0.125rem 0.625rem 0 hsla(0, 0%, 80%, 0.5);

    > button {
      width: inherit;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const ItemTextWrapper = styled(FlexCol)`
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: ${themeGet('space.4')}px;
`;
export const ItemTextSmall = styled(Text)`
  font-size: 14px;
  font-weight: 300;
  color: ${themeGet('colors.greyDarkest')};
`;
export const ItemTextLarge = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  color: ${themeGet('colors.blueDarker')};
`;

export const CartIconWrapper = styled('span')`
  position: relative;
`;

export const CartItemsCount = styled('span')`
  position: absolute;
  top: 2px;
  left: ${props => props.left};
  font-size: 14px;
  font-weight: 500;
  color: ${themeGet('colors.green')};
`;



// WEBPACK FOOTER //
// ./src/components/header/style.js